export const FETCH_ALL_CHAIR_RENTALS = 'FETCH_ALL_CHAIR_RENTALS';
export const FETCH_CHAIR_RENTAL = 'FETCH_CHAIR_RENTAL';
export const FETCH_CHAIR_RENTAL_PAYMENT_HISTORY = 'FETCH_CHAIR_RENTAL_PAYMENT_HISTORY';
export const FETCH_SINGLE_CHAIR_RENTAL_PAYMENT = 'FETCH_SINGLE_CHAIR_RENTAL_PAYMENT';
